module.exports = __webpack_public_path__ + "static/spacejam-d5a0cff7f3a87ab42d5c84382653b938.png";